export enum SignType {
  CANDIDATE = "CANDIDATE",
  ORGANIZATIONS = "ORGANIZATIONS"
}

export enum SignUIType {
  MAIN = "MAIN",
  LOGIN = "LOGIN",
  SIGNUP = "SIGNUP"
}